// Constants
import C from '@root/constants';

const xAPIStatement = () => {
	return `${C.API_BASE_URL}/xapi`;
};
export default xAPIStatement;
